/**
 * @generated SignedSource<<af945cfede58d89bcf85af21b1d2ba76>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteProjectBillToInput = {
  projectBillToId: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type DeleteProjectBillToMutation$variables = {
  input: DeleteProjectBillToInput;
};
export type DeleteProjectBillToMutation$data = {
  readonly deleteProjectBillTo: {
    readonly deletedProjectBillToId: string | null;
  } | null;
};
export type DeleteProjectBillToMutation$rawResponse = {
  readonly deleteProjectBillTo: {
    readonly deletedProjectBillToId: string | null;
  } | null;
};
export type DeleteProjectBillToMutation = {
  variables: DeleteProjectBillToMutation$variables;
  response: DeleteProjectBillToMutation$data;
  rawResponse: DeleteProjectBillToMutation$rawResponse;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteProjectBillToPayload",
    "kind": "LinkedField",
    "name": "deleteProjectBillTo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedProjectBillToId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteProjectBillToMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteProjectBillToMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "dd753f556e174f6c0e92aee5e93f729c",
    "id": null,
    "metadata": {},
    "name": "DeleteProjectBillToMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteProjectBillToMutation(\n  $input: DeleteProjectBillToInput!\n) {\n  deleteProjectBillTo(input: $input) {\n    deletedProjectBillToId\n  }\n}\n"
  }
};
})();

(node as any).hash = "82f53aadbc9fce94edb393d76f2add1d";

export default node;
